import { useState } from "react";
import { styles } from "../styles";
import SignaturePad from "./SignaturePad";

const hasTouch =
  typeof window !== "undefined" &&
  ("ontouchstart" in window || (navigator.maxTouchPoints || 0) > 0);

const SIG_FONT = "'Segoe Script', 'Brush Script MT', cursive";

// Render typed text into the same PNG data URL shape a drawn signature uses,
// so storage/printing don't care which mode was used.
const renderTyped = (text) => {
  if (!text.trim()) return "";
  const c = document.createElement("canvas");
  c.width = 300;
  c.height = 120;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#111";
  ctx.font = `34px ${SIG_FONT}`;
  ctx.textBaseline = "middle";
  ctx.fillText(text, 10, 60);
  return c.toDataURL("image/png");
};

/**
 * Signature capture with Draw / Type modes. Defaults to Type on non-touch
 * devices (laptops/desktops, where drawing with a mouse is awkward) and Draw
 * on touchscreens. Either way it reports a PNG data URL via onChange.
 */
export default function SignatureInput({ onChange }) {
  const [mode, setMode] = useState(hasTouch ? "draw" : "type");
  const [typed, setTyped] = useState("");

  const switchMode = (m) => {
    setMode(m);
    setTyped("");
    onChange("");
  };

  const tab = (m, label) => (
    <button
      type="button"
      onClick={() => switchMode(m)}
      style={{
        ...styles.button,
        padding: "2px 10px",
        background: mode === m ? "#1a5fb4" : undefined,
        color: mode === m ? "white" : undefined,
      }}
    >
      {label}
    </button>
  );

  return (
    <div>
      <div style={{ marginBottom: "4px" }}>
        {tab("type", "Type")}
        {tab("draw", "Draw")}
      </div>
      {mode === "draw" ? (
        <SignaturePad onChange={onChange} />
      ) : (
        <div>
          <input
            style={{ ...styles.input, width: "260px" }}
            placeholder="Type full name to sign"
            value={typed}
            onChange={(e) => {
              setTyped(e.target.value);
              onChange(renderTyped(e.target.value));
            }}
          />
          {typed && (
            <div
              style={{
                fontFamily: SIG_FONT,
                fontSize: "30px",
                borderBottom: "1px solid #999",
                width: "260px",
                marginTop: "4px",
                color: "#111",
              }}
            >
              {typed}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
